<template>
  <div
    class="relative bg-gray-900 rounded-2xl p-4 overflow-hidden"
    :class="{ grayscale: product.statuskala === 1 }"
  >
    <img
      class="w-24 h-24 mx-auto"
      :src="product.imgurl"
      @error="$event.target.src = require('@/assets/img/placeholder.png')"
    />
    <h1 class="text-white text-sm my-2 text-center h-10">
      {{ product.kala_Name }}
    </h1>
    <h5 class="text-gray-400 text-sm text-center">
      <!-- {{ $helper.priceFormatter(product.nerkh_With_Maliat / 10) }} -->
      {{ $helper.priceFormatter(product.nerkh_With_Maliat) }}
    </h5>

    <h6 class="text-gray-400 text-sm mt-2 text-center">
      موجودی:
      <span class="text-green-500">{{ product.mojodi }}</span>
    </h6>
    <div class="flex justify-between items-center mt-2 text-center">
      <span
        class="w-7 h-7 border border-yellow-300 bg-yellow-500 p-1 rounded-lg"
        @click="incrementCount"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation($event)"
        >+</span
      >

      <span class="text-white">{{ count }}</span>

      <span
        class="w-7 h-7 border border-yellow-300 bg-yellow-500 rounded-lg"
        @click="decrementCount"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation($event)"
        >-</span
      >
    </div>

    <div
      class="absolute top-0 left-0 bg-green-500 py-1 px-2 rounded-tl-lg rounded-br-lg text-xs"
      v-if="product.mojodi === 0 && product.kindFood !== -1"
      @click="chargeModal = true"
    >
      شارژ
    </div>

    <div
      class="absolute top-0 right-0 bg-amber-500 py-1 px-2 rounded-tr-lg rounded-bl-lg text-xs"
      v-if="product.description"
      @click="showDescriptionModal = true"
    >
      نوع
    </div>

    <div
      class="absolute top-0 right-0 h-full w-full bg-black/50"
      v-if="product.statuskala === 1"
    ></div>
  </div>

  <!--  Charge Modal -->
  <transition name="fade">
    <div
      class="flex justify-center items-center fixed top-0 bg-gray-500/60 h-full w-full left-0 right-0 z-20"
      v-if="chargeModal"
      @click="chargeModal = !chargeModal"
    >
      <div class="bg-gray-800 rounded-lg w-3/4 p-4" @click.stop>
        <h1 class="text-center text-white">ثبت پیگیری</h1>
        <form action="" class="mt-4" @submit.prevent="submitChargeRequest()">
          <Input
            type="number"
            placeholder="تعداد..."
            v-model="chargeQuantity"
            required
          />
          <Button class="mt-4" type="submit">ثبت</Button>
        </form>
      </div>
    </div>
  </transition>

  <!--  Select Description Modal -->
  <transition name="fade">
    <div
      class="flex justify-center items-center fixed top-0 bg-gray-500/60 h-full w-full left-0 right-0 z-20"
      v-if="descriptionModal"
    >
      <div class="bg-gray-800 rounded-lg w-3/4 p-4" @click.stop>
        <h1 class="text-center text-white">ثبت توضیحات</h1>
        <form action="" class="mt-4" @submit.prevent="saveDescription()">
          <div
            class="text-white flex justify-end [direction:ltr]"
            v-for="(tag, index) in tagList"
            :key="index"
          >
            <label class="pr-4" :for="`description${index}`">{{
              tag.value
            }}</label>
            <input
              :id="`description${index}`"
              type="radio"
              name="description"
              v-model="description"
              :value="tag.hint"
              required
            />
          </div>

          <Button class="mt-4" type="submit">ثبت</Button>
        </form>
      </div>
    </div>
  </transition>

  <!--  Edit Description Modal -->
  <transition name="fade">
    <div
      class="flex justify-center items-center fixed top-0 bg-gray-500/60 h-full w-full left-0 right-0 z-20"
      v-if="showDescriptionModal"
      @click="showDescriptionModal = !showDescriptionModal"
    >
      <div class="bg-gray-800 rounded-lg w-3/4 p-4" @click.stop>
        <h1 class="text-center text-white">توضیحات</h1>
        <form action="" class="mt-4">
          <Input type="text" :value="product.description" required disabled />
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from "./General/Button";
import { getTagList, postChargeRequest } from "../API/API";
import Input from "./Input";

export default {
  name: "VerticalFoodCard",
  components: { Input, Button },
  props: ["product"],
  data() {
    return {
      chargeModal: false,
      chargeQuantity: "",

      descriptionModal: false,
      description: "",
      tagList: [],

      showDescriptionModal: false,
    };
  },
  computed: {
    count() {
      return this.$store.getters.productCount(this.product.kala);
    },
  },
  methods: {
    incrementCount() {
      if (this.product.isNegative !== -1) {
        let getCart = this.$store.state.cart.products;
        const found = getCart.find((item) => item.isNegative === -1);
        if (found !== undefined) {
          const swalWithBootstrapButtons = this.$swal.mixin({
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: true,
          });
          swalWithBootstrapButtons
            .fire({
              title: "",
              text: " درصورت ویرایش کسر برنج وکسر سرویس حذف میشود آیا ادامه می دهید ؟",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "بله",
              cancelButtonText: "خیر",
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                if (this.product.isNegative !== -1) {
                  getCart.forEach((item) => {
                    if (item.isNegative === -1 && item.quantity > 0) {
                      let index = this.$store.state.cart.products.findIndex(
                        (x) => item.kala === x.kala
                      );
                      this.$store.state.cart.products[index].quantity = 0;
                    }
                  });
                  this.$store
                    .dispatch("addProduct", this.product)
                    .then(async (resp) => {
                      if (resp === "getDescription") {
                        this.tagList = (
                          await getTagList(this.product.kala)
                        ).data.result;
                        this.descriptionModal = true;
                      }
                    })
                    .catch((err) => {
                      this.$swal({
                        icon: "error",
                        title: "خطا",
                        text: err,
                        confirmButtonColor: "#fcd34d",
                        confirmButtonText: "باشه",
                      });
                    });
                } else {
                  this.$store
                    .dispatch("addProduct", this.product)
                    .then(async (resp) => {
                      if (resp === "getDescription") {
                        this.tagList = (
                          await getTagList(this.product.kala)
                        ).data.result;
                        this.descriptionModal = true;
                      }
                    })
                    .catch((err) => {
                      this.$swal({
                        icon: "error",
                        title: "خطا",
                        text: err,
                        confirmButtonColor: "#fcd34d",
                        confirmButtonText: "باشه",
                      });
                    });
                }
              }
            });
        } else {
          this.$store.dispatch("addProduct", this.product)
            .then(async (resp) => {
              if (resp === "getDescription") {
                this.tagList = (
                  await getTagList(this.product.kala)
                ).data.result;
                this.descriptionModal = true;
              }
            })
            .catch((err) => {
              this.$swal({
                icon: "error",
                title: "خطا",
                text: err,
                confirmButtonColor: "#fcd34d",
                confirmButtonText: "باشه",
              });
            });
        }
      } else {
        this.$store
          .dispatch("addProduct", this.product)
          .then(async (resp) => {
            if (resp === "getDescription") {
              this.tagList = (await getTagList(this.product.kala)).data.result;
              this.descriptionModal = true;
            }
          })
          .catch((err) => {
            this.$swal({
              icon: "error",
              title: "خطا",
              text: err,
              confirmButtonColor: "#fcd34d",
              confirmButtonText: "باشه",
            });
          });
      }
    },
    decrementCount() {
      if (this.product.isNegative !== -1) {
        let getCart = this.$store.state.cart.products;
        const found = getCart.find((item) => item.isNegative === -1);

        if (found !== undefined) {
          const swalWithBootstrapButtons = this.$swal.mixin({
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: true,
          });
          swalWithBootstrapButtons
            .fire({
              title: "",
              text: " درصورت ویرایش کسر برنج وکسر سرویس حذف میشود آیا ادامه می دهید ؟",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "بله",
              cancelButtonText: "خیر",
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                if (this.product.isNegative !== -1) {
                  getCart.forEach((item) => {
                    if (item.isNegative === -1 && item.quantity > 0) {
                      let index = this.$store.state.cart.products.findIndex(
                        (x) => item.kala === x.kala
                      );
                      this.$store.state.cart.products[index].quantity = 0;
                    }
                  });
                  this.$store.dispatch("removeProduct", this.product);
                } else {
                  this.$store.dispatch("removeProduct", this.product);
                }
              }
            });
        } else {
          this.$store.dispatch("removeProduct", this.product);
        }
      } else {
        this.$store.dispatch("removeProduct", this.product);
      }
    },
    toggleAnimation(event) {
      // event.currentTarget.classList.toggle('scale-95')
      event.currentTarget.classList.toggle("bg-yellow-300");
    },
    submitChargeRequest() {
      let chargeRequest = {
        ProductId: this.product.kala,
        RequesrQty: this.chargeQuantity,
      };

      postChargeRequest(chargeRequest)
        .then((resp) => {
          this.$swal({
            icon: "success",
            title: "موفق",
            text: resp.data.result,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        })
        .finally(() => {
          this.chargeModal = false;
        });
    },
    saveDescription() {
      this.$store.dispatch("addDescription", {
        product: this.product,
        description: this.description,
      });
      this.descriptionModal = false;
      this.description = "";
    },
  },
};
</script>

<style scoped></style>
